import React, { useContext, useEffect } from 'react'
import { MicroPartnerCard, MicroPartnerCardHeader, CloseIcon, CompanyNameText } from './micro_partner_card.styles'
import { computedPartnerBadge } from '../../../../../util/partner_status_helper'
import { useTranslation } from 'react-i18next'
import { directoryStrings } from '../../../directory_i18n_mappings'
import { LopContext } from '../../../../../util/language_preference_provider/language_preference_provider'
import { ComparedPartnersContext } from '../../partner_comparison/compared_partners_context'
import { Accreditation, Maybe } from '../../../../../generated/graphql'
import { removeComparedPartnerInCartMetricHandler } from '../../../../../util/partner_comparison_metrics_helper'
import { getMetricsPublisherChainAsync } from '@amzn/aapn-front-end-metrics'

export interface MicroPartnerCompareCardProps {
  type: 'stickyHeader' | 'partnerComparisonCart'
  partnerId?: string
  partnerName?: string
  partnerAccreditation?: Maybe<Array<Maybe<Accreditation>>>
  isLanguageOfPreferenceSupported: boolean
}
export const MicroPartnerCompareCard: React.FunctionComponent<MicroPartnerCompareCardProps> = (props: MicroPartnerCompareCardProps): JSX.Element => {
  const { type, partnerId, partnerName, partnerAccreditation, isLanguageOfPreferenceSupported } = props
  const { t } = useTranslation()
  const lopContext = useContext(LopContext)
  const { removeSelectedPartner } = useContext(ComparedPartnersContext)

  const removePartner = (): void => {
    if (partnerId) {
      if (type === 'stickyHeader') {
        getMetricsPublisherChainAsync('ComparedPartnersOnStickyHeader').then(p => {
          p.publishCounter('microPartnerComparisonCard.stickyHeader.remove.click', 1).publishString(
            'microPartnerComparisonCard.stickyHeader.remove.partnerId',
            partnerId,
          )
        })
      } else if (type === 'partnerComparisonCart') {
        removeComparedPartnerInCartMetricHandler(partnerId)
      }
      removeSelectedPartner(partnerId)
    }
  }

  useEffect(() => {
    if (!isLanguageOfPreferenceSupported) {
      partnerId && removeSelectedPartner(partnerId)
    }
  }, [isLanguageOfPreferenceSupported, removeSelectedPartner, partnerId])

  const badge = computedPartnerBadge(t, partnerAccreditation)

  return (
    <MicroPartnerCard isRtl={lopContext.lopRtl} padding={'small'}>
      <MicroPartnerCardHeader hasBadge={!!badge}>
        {badge}
        <CloseIcon type={'times'} size={'sm'} onClick={removePartner} role="img" aria-label={t(directoryStrings.REMOVE_PARTNER_LABEL)} className="icon" />
      </MicroPartnerCardHeader>
      <CompanyNameText type={'h3'}>{partnerName}</CompanyNameText>
    </MicroPartnerCard>
  )
}
